import { OrgModalLocale } from "../index";

const locale: OrgModalLocale = {
  name: '名称',
  code: '编码',
  domain: '域',
  owner: '管理账号',
  desc: '描述',
};

export default locale
